export const FEEDBACK = 'Feedback'
export const DETAILS = 'Details'
export const REVIEW = 'Review'
export const ACTION_COMPLETE = 'Action Complete'

export const STEPS = [FEEDBACK, DETAILS, REVIEW, ACTION_COMPLETE]
